<template>
  <upload-works />
</template>

<script>
import uploadWorks from "../../classCourse/uploadWorks.vue";
export default {
  components: {
    uploadWorks,
  },
};
</script>

<style lang="less" scoped>
</style>